<template>
	<div id="app">
		<BhLoading :show="loading" :loadingText="true" />
		<MediaSelector :multiple="multipleImages" />
		<router-view />
	</div>
</template>

<script>
import MediaSelector from 'bh-mod/components/file/MediaSelector'
import BhLoading from 'bh-mod/components/common/Loading'

export default {
	name: 'app',
	components: { MediaSelector, BhLoading },
	computed: {
		loading() {
			return this.$store.state.loading
		},
		multipleImages() {
			return this.$store.state.appData.multipleImages
		}
	},
	watch: {
		'$route'(to, from) {
			if (document.querySelector('.scrolling-shadow')) {
				document.querySelector('.scrolling-shadow').classList.remove('scrolling-shadow')
			}
			const query = Object.assign({}, to.query)
			this.$store.commit('SETUP_URL_SETTINGS', query)
			if (to.path === '/settings') {
				this.$store.commit("SIDEBAR_SELECTION", 'Settings');
			} else if (to.path === '/archived') {
				this.$store.commit("SIDEBAR_SELECTION", 'Archived');
			} else {
				this.$store.commit("SIDEBAR_SELECTION", 'Workflows');
			}
		},
	},
	methods: {

	}
}
</script>
<style>
#app {
	min-height: 100vh;
}

iframe {
	border: 0;
}

.ant-drawer-header-no-title [aria-label="Close"] {
	background: white;
}

.badge-offer {
	padding: .35rem .65rem;
	text-align: center;
	display: inline-block;
	border-radius: .2rem;
	background: #aaa;
}

.bg-green {
	background-color: var(--green);
	color: white;
}
</style>
